import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ui-badges',
  templateUrl: './ui-badges.component.html',
  styleUrls: ['./ui-badges.component.scss']
})
export class UiBadgesComponent implements OnInit {
  viewTab: boolean = true;
  codeTab: boolean;

  constructor() { }

  ngOnInit(): void {
  }

  onMenuTab(number) {
    this.viewTab = false;
    this.codeTab = false;

    if (number == '1') {
      this.viewTab = true;
    }
    else if (number == '2') {
      this.codeTab = true;
    }
  }

}
